module.exports = __webpack_public_path__ + "img/27.9cbbea8d.jpg";